import { axiosInterceptors } from '~/utils/axiosInterceptor'

class BracketApi {
	constructor(axios, baseUrl) {
		this.axios = axios
		this.baseUrl = baseUrl
	}

	getBracket(segmentId, bracketNumber) {
		return this.axios.get(
			`${this.baseUrl}/matches/1.0/bracket/${segmentId}/match-series?filter[bracket.number]=${bracketNumber}`
		)
	}
}

export default ({ $axios, $config }, inject) => {
	const bracketApi = $axios.create({
		transformRequest: (data, headers) => {
			headers.Accept = 'application/json'
			if ($config.enableXStatusCode) {
				headers['X-Status-Code'] = true
			}
			return JSON.stringify(data)
		},
	})

	axiosInterceptors(bracketApi)
	inject('bracketApi', new BracketApi(bracketApi, $config.apiBaseUrl))
}
